// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d52bff67","453":"2cb199a8","455":"0f6dde6f","977":"7c4171b5"}[chunkId] + ".chunk.js";
};